function _(e,i,r){var s=e(473);r.Widgets=s,e(108).register_models(s)}
//# sourceMappingURL=main.min.js.map